var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { css, mq, styled } from "../utils";
var StyledWizardIntroCard = styled.div(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    box-sizing: border-box;\n    background-color: ", ";\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n    min-height: 550px;\n\n    button {\n      margin: 0 auto;\n      padding: 0 4rem;\n    }\n\n    ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    text-align: center;\n    box-sizing: border-box;\n    background-color: ", ";\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n    min-height: 550px;\n\n    button {\n      margin: 0 auto;\n      padding: 0 4rem;\n    }\n\n    ",
        ";\n  "])), colors.white, mq({
        padding: ['1rem', '3rem'],
    }));
});
var WizardIntroCard = function (_a) {
    var children = _a.children;
    return (React.createElement(StyledWizardIntroCard, null, children));
};
export default WizardIntroCard;
var templateObject_1;
//# sourceMappingURL=WizardIntroCard.js.map